import { events, siteSlogan, statCards } from "@/mocks/guaData";

export default function Hero() {
  const tickerItems = [...events.slice(0, 6), ...events.slice(0, 6)];

  return (
    <section id="top" className="relative overflow-hidden bg-background-900">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20wall%20of%20trending%20news%20cards%2C%20floating%20ticket%20labels%20and%20search%20icons%2C%20warm%20cream%20background%20with%20watermelon%20red%20and%20honey%20amber%20accents%2C%20modern%20popular%20ranking%20portal%20concept%2C%20flat%20design%20with%20soft%20shadows%2C%20no%20real%20people%2C%20no%20text&width=1600&height=900&seq=hero-gua&orientation=landscape"
          alt="吃瓜榜单热门瓜田热度排行门户首屏背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/25 via-transparent to-transparent"></div>
      </div>

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-7xl flex-col justify-center px-4 pt-28 pb-16 md:min-h-[680px] md:px-6">
        <div className="fade-up max-w-3xl">
          <p className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-fire-line text-[14px] text-accent-400"></i>
            </span>
            全网娱乐热点 · 每日滚动更新
          </p>

          <h1 className="mt-6 text-3xl leading-tight font-bold text-background-50 sm:text-4xl md:text-5xl md:leading-tight">
            今天，谁在风口浪尖？
            <br />
            吃瓜榜单帮你<span className="text-accent-400">一眼看清</span>
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            {siteSlogan}。聚合影视综艺、热搜词条、品牌与音乐现场等全网最热事件，按热度实时排序。想看谁最火、谁在涨，
            点开就知道——理性吃瓜，不迷路。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#rank"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-bar-chart-2-line text-[15px]"></i>
              </span>
              查看今日热榜
            </a>
            <a
              href="#feed"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              去瓜田逛逛
            </a>
          </div>
        </div>

        <dl className="mt-12 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3">
          {statCards.map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-3 rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-3 backdrop-blur"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className={`${s.icon} text-[18px]`}></i>
              </span>
              <div className="leading-tight">
                <dt className="text-xs text-background-100">{s.label}</dt>
                <dd className="font-heading text-lg font-bold text-background-50">{s.value}</dd>
              </div>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-t border-background-50/15 bg-background-950/60 backdrop-blur">
        <div className="overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8 px-4 py-3">
            {tickerItems.map((item, i) => (
              <a
                href="#feed"
                key={`${item.id}-${i}`}
                className="flex items-center gap-2 whitespace-nowrap text-sm text-background-100 transition-colors hover:text-accent-400"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-sparkling-2-line text-[14px] text-accent-400"></i>
                </span>
                <span className="max-w-[220px] truncate sm:max-w-xs">{item.title}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}